"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Laurel = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M51.546 55.135s-29.302-9.93-31.828-37.718c0 0 35.117 13.275 31.828 37.718m25.51 17.9s-19.27-24.228-6.318-48.938c0 0 22.312 30.209 6.319 48.937m-2.445 2.281s-25.825 17.048-49.283 1.922c0 0 32.07-19.537 49.283-1.922m42.226 23.734s-22.58-21.103-13.401-47.466c-.027-.067 26.503 26.574 13.401 47.466m45.894 12.493s-27.312-14.496-25.287-42.344c0 0 32.504 18.793 25.287 42.344m47.907 6.756s-29.921-7.817-34.435-35.344c0 0 35.961 10.763 34.435 35.344m-.563 3.298s-10.416 29.151-38.261 31.157c0 0 13.884-34.859 38.261-31.157m48.269 3.857s-6.128 30.34-33.342 36.367c0 0 8.689-36.546 33.342-36.367m.059-3.35s-30.721-3.393-39.2-30.01l.01.001.037.006h.001c1.493.237 37.228 5.909 39.152 30.003m-96.98-7.482s-16.884 25.915-44.455 21.411c0 0 21.616-30.699 44.455-21.411m-46.679-12.982s-23.047 20.654-48.465 9.114c0 0 28.827-24.002 48.465-9.114M389.17 71.3s8.51 29.737-12.959 47.612c0 0-9.024-36.447 12.959-47.611m38.59-28.745s11.967 28.52-7.238 48.809c0 0-13.27-35.124 7.238-48.81m-40.079 25.733s-28.848 11.13-48.555-8.649c0 0 35.495-12.236 48.555 8.649m38.239-28.539s-27.329 14.465-49.237-2.845c0 0 33.799-16.348 49.237 2.845m-79.243 56.497s4.46 30.625-19.213 45.418c0 0-4.053-37.291 19.213-45.418m-1.009-3.18s-30.072 7.14-46.957-15.09c-.07-.014 36.797-7.381 46.957 15.09m-41.771 22.176s-1.648 30.901-27.757 40.768c0 0 3.359-37.401 27.757-40.768m-.375-3.325s-30.938 1.089-43.104-24.016c0 0 37.555.021 43.104 24.016"
    fill="currentColor"
  />,
  "LeafIcon",
  {
    viewBox: "0 0 448 250",
    fill: "none",
    width: "448",
    height: "250",
    color: "#50583D",
  }
);
